import { render } from "./hero.vue?vue&type=template&id=18c2bfa6&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=18c2bfa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c2bfa6"],['__file',"src/js/components/hero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c2bfa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c2bfa6', __exports__)) {
    api.reload('18c2bfa6', __exports__)
  }
  
  module.hot.accept("./hero.vue?vue&type=template&id=18c2bfa6&scoped=true", () => {
    api.rerender('18c2bfa6', render)
  })

}


export default __exports__